export default function Written({ question, onAnswer, currentText }) {
  return (
    <div className="question written">
      <h6 className="mb-3" style={{ fontWeight: "600", fontSize: "18px" }}>
        {question.text}
      </h6>

      <textarea
        name={`question_${question.id}`}
        rows="5"
        placeholder="اكتب إجابتك هنا..."
        value={currentText}
        onChange={(e) => onAnswer(question.id, e.target.value)}
        style={{
          width: "100%",
          padding: "15px",
          borderRadius: "10px",
          border: "2px solid var(--brand-200)",
          backgroundColor: "#f9f9f9",
          fontSize: "16px",
          fontWeight: "500",
          color: "#333",
          transition: "all 0.3s ease",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
          resize: "vertical",
        }}
      />
    </div>
  );
}
